/**
 * 描述：基础管理 --- 审计作业模板维护（接口管理）
 * 录入人： 王帅
 */
import request from '../request.js'


/**
 * 描述：左侧菜单树 列表查询
 * 接口管理员：崔北超
 * 参数：{}
 */
export const getLeftMenu = function (data) {
    return request({
        url: 'templateAudit/getOpeTemplateAuditMenu',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: false
        },
    })
}

/**
 * 描述：根据左侧菜单 查询对应的 模板信息
 * 接口管理员：崔北超
 * 参数：
 * {
 *      pid: '',
 *      sname: ''
 * }
 */
export const getRightData = function (data) {
    return request({
        url: 'templateAudit/getOpeTemplateAuditList',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: false
        },
    })
}

/**
 * 描述：删除对应的 左侧模板
 * 接口管理员：崔北超
 * 参数：
 * {
 *      id: '',     // 当前节点ID
 *      pid: '',    // 父节点ID
 *      sort: ''    // 当前节点排序
 * }
 */
export const removeTemplate = function (data) {
    return request({
        url: 'templateAudit/removeOpeTemplateAuditById',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: false
        },
    })
}

/**
 * 描述：启用、禁用 对应的 左侧模板
 * 接口管理员：崔北超
 * 参数：
 * {
 *      id: '',         // 当前节点ID
 *      status: '',    // 当前状态
 * }
 */
export const changeStatus = function (data) {
    return request({
        url: 'templateAudit/updateOpeTemplateAuditStatus',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: false
        },
    })
}

/**
 * 描述：新增、编辑
 * 接口管理员：崔北超
 * 参数：
{
    id: '',
    sname: '',
    pid: '0',
    content: '',
    requires: '',
    gist: '',
    type: '',
    applys: '',
    sort: '',
    remark: ''
}
 */
export const saveOrUpdate = function (data) {
    return request({
        url: 'templateAudit/saveOrUpdateOpeTemplateAudit',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: false
        },
    })
}


/**
 * 描述：查看事项详情
 * 接口管理员：崔北超
 * 参数：
{
    id: ''
}
 */
export const getDetail = function (data) {
    return request({
        url: 'templateAudit/getOpeTemplateAuditById',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: false
        },
    })
}


/**
 * 描述：更改顺序
 * 接口管理员：崔北超
 * 参数：
{
    id: '',
    type: '1',    // 1 上移， 2 下移
    sort: '',   // 当前排序
    pid: ''
}
 */
export const changeSort = function (data) {
    return request({
        url: 'templateAudit/updateSort',
        method: 'post',
        data,
        requestConfig: {
            needTenantId: false
        },
    })
}